/**
 * Url utilities.
 *
 * @author Erik Jan Lam
 * @date Dec 14 2018
 */

var $ = require('jquery');

/**
 * @function
 * @description appends the parameter with the given name and value to the given url and returns the changed url
 * @param {String} url the url to which the parameter will be added
 * @param {String} name the name of the parameter
 * @param {String} value the value of the parameter
 */
function appendParamToURL(url, name, value) {
    var separator;
    // quit if the param already exists
    if (url.indexOf(name + '=') !== -1) {
        return url;
    }
    separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + name + '=' + encodeURIComponent(value);
}

exports.appendParamToURL = appendParamToURL;

/**
 * @function
 * @description appends the parameters to the given url and returns the changed url
 * @param {String} url the url to which the parameters will be added
 * @param {Object} params
 */
function appendParamsToUrl(url, params) {
    var theUrl = url;
    $.each(
        params,
        function (name, value) {
            theUrl = appendParamToURL(theUrl, name, value);
        }.bind(this)
    );
    return theUrl;
}

exports.appendParamsToUrl = appendParamsToUrl;

/**
 * @function
 * @description Appends the parameter 'format=ajax' to a given path
 * @param {String} path the relative path
 */
function ajaxUrl(path) {
    return appendParamToURL(path, 'format', 'ajax');
}

exports.ajaxUrl = ajaxUrl;

function getParameterByName(name, url) {
    var regex;
    var results;
    if (!url) url = window.location.href; // eslint-disable-line no-param-reassign
    name = name.replace(/[[\]]/g, '\\$&'); // eslint-disable-line no-param-reassign
    regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

exports.getParameterByName = getParameterByName;
